import React from 'react';

export interface EmptyStateProps {
  icon?: React.ReactNode;
  title: string;
  description?: string;
  action?: React.ReactNode;
  className?: string;
}

const EmptyState: React.FC<EmptyStateProps> = ({
  icon,
  title,
  description,
  action,
  className,
}) => (
  <div className={['rr-empty', className].filter(Boolean).join(' ')}>
    {icon && <div className="rr-empty-icon">{icon}</div>}
    <h3 className="rr-empty-title">{title}</h3>
    {description && <p className="rr-empty-description">{description}</p>}
    {action && <div className="rr-empty-action">{action}</div>}
  </div>
);

export default EmptyState;
